package com.essntl.features.invoice.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import core.dateformat.utils.parseLocalDateOrNull
import com.essntl.features.invoice.ui.addeditinvoice.components.sidebar.PriceDetailsUiState
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus

@Composable
fun rememberLocalDate(
    index: Int,
    fromDate: String?,
): LocalDate? {
    return remember(index, fromDate) {
        parseLocalDateOrNull(fromDate)?.plus(DatePeriod(days = index))
    }
}

@Composable
fun rememberDayProposalServiceList(
    localDate: LocalDate?,
    proposalServiceList: List<ProposalServiceModel>,
): List<ProposalServiceModel> {
    return remember(localDate, proposalServiceList) {
        proposalServiceList
            .filter { it.startDate == localDate.toString() }
            .sortedBy { it.index }
    }
}

@Composable
fun rememberItineraryServiceList(
    localDate: LocalDate?,
    itineraryServiceList: List<ItineraryServiceModel>,
): List<ItineraryServiceModel> {
    return remember(localDate, itineraryServiceList) {
        itineraryServiceList
            .filter { it.startDate == localDate.toString() }
    }
}

@Composable
fun rememberProposalServicesPriceDetailsList(
    getAllProposalServices: List<ProposalServiceModel>,
    checkedServiceIds: Set<String>,
): List<PriceDetailsUiState> {
    return remember(
        getAllProposalServices,
        checkedServiceIds,
    ) {
        checkedServiceIds
            .mapNotNull { id ->
                val proposalService = getAllProposalServices
                    .find {
                        it.id == id &&
                            it.paid != true &&
                            it.archived != true
                    }
                    ?: return@mapNotNull null


                PriceDetailsUiState(
                    title = proposalService.service.title,
                    price = proposalService.price ?: 0,
                )
            }
    }
}

@Composable
fun rememberItineraryServicesPriceDetailsList(
    getAllItineraryServices: List<ItineraryServiceModel>,
    checkedServiceIds: Set<String>,
): List<PriceDetailsUiState> {
    return remember(
        getAllItineraryServices,
        checkedServiceIds,
    ) {
        checkedServiceIds
            .mapNotNull { id ->
                val proposalService = getAllItineraryServices
                    .find {
                        it.id == id &&
                            it.status != ItineraryServiceModel.Status.Cancelled
                    }
                    ?: return@mapNotNull null


                PriceDetailsUiState(
                    title = proposalService.service.title,
                    price = proposalService.price ?: 0,
                )
            }
    }
}